const normalizeBase = (value) => {
    if (!value) return '';
    return value.replace(/\/+$/, '');
};

const defaultSiteUrl = 'https://code-pro.ir';
const apiBase =
    defaultSiteUrl;
export const API_BASE_URL = apiBase;
export const ADMIN_API_BASE = `${apiBase}/api/v1/admin`;
export const BLOG_API_BASE = `${apiBase}/api/v1/blog`;
export const APP_API_BASE = `${apiBase}/api/v1/app`;

export const SITE_BASE_URL =
    defaultSiteUrl;
